import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'

/**
 * Validates if a user-entered regular expression pattern is valid regex.
 * This only checks that the given pattern may be used to create a RegExp
 * without throwing an error.
 * For actual input validation that *uses* a regular expression,
 * {@see scoreboard/components/validators/regexp-validator-factory.js} usage
 *
 * @param val - the user-entered regular expression
 */
function regexPatternValidator(val) {
	if (_.isEmpty(val)) {
		return
	}

	try {
		new RegExp(val, 'u')
	} catch (e) {
		return i18n.get('forms.widgets.inputValidation.regexPattern')
	}
}

export default regexPatternValidator
regexPatternValidator.__filename__ = 'forms/widgets/regex-pattern-validator.js'
